import styled from 'styled-components';
import { BODY_TEXT_COLOR, NEGATIVE_COLOR, THIRD_COLOR } from "../../config/colors";

export const CONTAINER_HEIGHT = '100%';

export const STYLES = {
  closeIconWrap: { position: 'absolute', right: '10px', top: '10px' },
  floatingText: { color: NEGATIVE_COLOR },
  textField: {
    width: '100%', fontSize: '16px', fontWeight: '400', color: BODY_TEXT_COLOR,
  },
  underlineStyle: { borderColor: BODY_TEXT_COLOR },
  closeIcon: { height: '35px', width: '35px', color: THIRD_COLOR },
  labelStyle: { fontWeight: 700 },
};


export const FormWrapperDiv = styled.div`
display: flex;
color: ${BODY_TEXT_COLOR};
flex-direction: column;
font-size: 18px;
align-items: center;
justify-content: center;
margin: 20px auto 20px;
height: 100%;
font-family: Roboto', sans-serif;
`;



// WEBPACK FOOTER //
// ./src/components/ResetPasswordModal/styles.js